import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { applicationUrls } from 'sharedweb/helpers/urls';
import { tap, map } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MarketAnalyticsService {

  private _catchedSymbolData: Map<number,{}> = new Map();//key is symbolid and value is symbol data recieved from server
  private _catchedIndicesSymbolId: Map<number,{}> = new Map();//key is marketid and in object key is securityid and value is symbolid
  constructor(
      private _httpClient: HttpClient,
    ) {
  }
  
  getSpecificSymbolDetails(data):any{
    if(this._catchedSymbolData && this._catchedSymbolData.size){
      let response ={'data':[]}
      /**
       * filtering symbolids which are not present in catchedSymbolData
       */
      const symbolIdsToSend = data.symbolIds.filter(el => !Array.from(this._catchedSymbolData.keys()).includes(el));
      if(symbolIdsToSend && symbolIdsToSend.length){
        /**
         * sending request for only the symbolids which are not present in the catchedSymbolData
         */
        const dataToSend = {
          symbolIds: symbolIdsToSend,
          is_index: data.is_index
        }
        const url = applicationUrls.specificSymbol;
        return this._httpClient.post<any>(url, 
        dataToSend
      ).map(res =>{
          for(let i = 0; i<res.data.length; i++){
            this._catchedSymbolData.set(dataToSend.symbolIds[i],res.data[i]);
          }
          for(let i=0;i<data.symbolIds.length;i++){
            response.data.push(this._catchedSymbolData.get(data.symbolIds[i]));
          }
          return response;
      });
      }
      for(let i=0;i<data.symbolIds.length;i++){
        response.data.push(this._catchedSymbolData.get(data.symbolIds[i]));
      }
      return of(response);
    }
    else{
      const url = applicationUrls.specificSymbol;
      const response =  this._httpClient.post<any>(url, 
        data
      ).pipe(tap(res =>{
          for(let i = 0; i<res.data.length; i++){
            this._catchedSymbolData.set(data.symbolIds[i],res.data[i]);
          }
      }));
      return response;
    }
  }

  getSymbolInfo(data){
    if(this._catchedIndicesSymbolId.has(data.market_id)){
        const keys = Object.keys(this._catchedIndicesSymbolId.get(data.market_id));
        /**
       * converting security_id to string because Object.keys() returns an array whose elements are strings
       */
        if(keys.includes(data.security_id.toString())){
          return of(this._catchedIndicesSymbolId.get(data.market_id)[data.security_id]);
        }
    }
      const url = applicationUrls.specificSymbol;
      const response =  this._httpClient.get<any>(url, 
        {params:data}
      ).pipe(tap(res =>{
          if(!this._catchedIndicesSymbolId.has(data.market_id)){
            this._catchedIndicesSymbolId.set(data.market_id,{});
          }
          this._catchedIndicesSymbolId.get(data.market_id)[data.security_id] = {'symbol_id':res.symbol_id};
      }));
      return response;
  }
}
